import HttpRequest from './HttpRequest'

class EmailTemplateProvider extends HttpRequest {
  findAll () {
    return this.get('/email-setting')
  }

  findOne (id) {
    return this.get(`/email-setting/${id}`)
  }

  create (payload) {
    return this.post('/email-setting', payload)
  }

  update (id, payload) {
    return this.patch(`/email-setting/${id}`, payload)
  }

  softDelete (id) {
    return this.delete(`/email-setting/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/email-setting?page=${page}&limit=${limit}`, query)
  }
}

export default EmailTemplateProvider
